import React from "react"
import FeatureDivider from "../components/featureDivider"
import { Link } from "gatsby"

const FeaturedContent = ({ header, destination, textAlignment, children, buttonLink, buttonText }) => {
  const headerText = <h2 className="is-size-4 is-size-5-mobile my-4 has-text-danger is-uppercase" >{header}</h2>
  
  return (
    <section className="section">
      <div className={`featured-content container ${textAlignment === "center" ? "has-text-centered" : ""}`}>
        {header
          ? (destination
            ? <Link to={destination}>{headerText}</Link>
            : <>{headerText}</>
          )
          : null
        }
        {header && <FeatureDivider/>}
        <div className="content">{ children }</div>
        {buttonLink &&
          <a
            href={buttonLink}
            className="button is-danger is-uppercase"
          >
            {buttonText}
          </a>
        }
      </div>
    </section>
  )
}

export default FeaturedContent
